import { EditorState, generateName } from "@common/Common";
import { ValidationError } from "@common/types";

export class FormEditorViewModel
{
    state: EditorState = EditorState.Closed;
    title: string | null = null;
    confirmButtonLabel: string | null = null;

    id: number | null = null;
    name: string | null = null;
    oldName: string | null = null;
    sourceId: number | null = null;

    nameError: string | null = null;

    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator()
    {
        this.title = "Create a form";
        this.confirmButtonLabel = "Create";

        this.id = 0;
        this.name = generateName("Form");
        this.oldName = null;
        this.sourceId = null;

        this.state = EditorState.Creator;
    }

    showCloner(sourceId: number, sourceName: string)
    {
        this.title = "Cloner the form";
        this.confirmButtonLabel = "Create";

        this.id = 0;
        this.name = generateName(sourceName);
        this.oldName = null;
        this.sourceId = sourceId;

        this.state = EditorState.Cloner;
    }

    showEditor(id: number, name: string)
    {
        this.title = "Edit the form";
        this.confirmButtonLabel = "Update";

        this.id = id;
        this.name = name;
        this.oldName = name;
        this.sourceId = null;

        this.state = EditorState.Editor;
    }

    close()
    {
        this.state = EditorState.Closed;

        this.id = null;
        this.name = null;
        this.oldName = null;
        this.sourceId = null;

        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.nameError = errors[0].Error;
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }
}

export class FormEditorSaveEventPayload
{
    id: number;
    name: string;
    sourceId: number | null;

    constructor(id: number, name: string, sourceId: number | null)
    {
        this.id = id;
        this.name = name;
        this.sourceId = sourceId;
    }
}